import request from '@/utils/request'
/**
 *
 * 商品管理
 *
 **/
// 查询列表接口
export const getCommodityPage = (params: any) => {
    return request({
      url: '/commodity/page',
      method: 'get',
      params
    })
  }

  // 商品启售停售
export const commodityStatusByStatus = (params: any) => {
  return request({
    url: `/commodity/status/${params.status}`,
    method: 'post',
    params: { id: params.id }
  })
}

  // 商品包邮不包邮
export const commodityPostageByPostage = (params: any) => {
  return request({
    url: `/commodity/postage/${params.postage}`,
    method: 'post',
    params: { id: params.id }
  })
}

 // 将商品添加到限时价表
 export const addLimitedTimePrice = (id: string | (string | null)[]) => {
  return request({
    url: `/commodity/addLimitedTimePrice/${id}`,
    method: 'post',
  })
}

// 删除接口
export const deleteCommodity = (ids: string) => {
  return request({
    url: '/commodity',
    method: 'delete',
    params: { ids }
  })
}

// 新增接口
export const addCommodity = (params: any) => {
  return request({
    url: '/commodity',
    method: 'post',
    data: { ...params }
  })
}

// 查询详情
export const queryCommodityById = (id: string | (string | null)[]) => {
  return request({
    url: `/commodity/${id}`,
    method: 'get'
  })
}

// 修改接口
export const editCommodity = (params: any) => {
  return request({
    url: '/commodity',
    method: 'put',
    data: { ...params }
  })
}

//商品分类数据查询
export const commodityCategoryList = (params: any) => {
  return request({
    url: `/category/list`,
    method: 'get',
    params: { ...params }
  })
}

